export default function Footer(){  
    return  <footer className="py-1">
                <p className="text-center text-white mt-1 ">
                    Manikandan D - 2024, All Rights Reserved
                </p>
            </footer>
}